import { Grid, Hidden } from "@material-ui/core";
import { partition } from "lodash";
import { useContext, useMemo } from "react";
import { Widget } from "../../../components/widget";
import { StakeContext } from "../single/context";
import { DesktopList } from "./desktop";
import { MobileList } from "./mobile";

export interface IAllStakingContractsProps { }

export function AllStakingContractsPage(props: IAllStakingContractsProps) {
  const { allContracts } = useContext(StakeContext);

  const allContractsResult = useMemo(
    () => allContracts.map((x) => partition(x, (y) => y.stakingAllowed)),
    [allContracts]
  );

  return allContractsResult.fold(
    () => null,
    ([activeContracts, inactiveContracts]) => (
      <Grid container spacing={3}>
        {activeContracts.length > 0 ? (
          <Grid item xs={12}>
            <Widget title="Active Reward Pools">
              <Hidden smDown>
                <DesktopList contracts={activeContracts} />
              </Hidden>
              <Hidden mdUp>
                <MobileList contracts={activeContracts} />
              </Hidden>
            </Widget>
          </Grid>
        ) : null}
        {inactiveContracts.length > 0 ? (
          <Grid item xs={12}>
            <Widget title="Closed Reward Pools">
              <Hidden smDown>
                <DesktopList contracts={inactiveContracts} />
              </Hidden>
              <Hidden mdUp>
                <MobileList contracts={inactiveContracts} />
              </Hidden>
            </Widget>
          </Grid>
        ) : null}
      </Grid>
    )
  );
}
